import { useParams } from "react-router-dom";
import "./style.css"
import { Helmet } from "react-helmet-async";
import { useEffect, useRef, useState } from "react";
import { Heart, Trash } from "react-feather";
import Spinner, { LoadingThreeCircle } from "../../../global-components/src/components/spinner/spiner";
import { LIMIT_REQUEST_COMMENTS } from "../../../utils/vars";
import { useAuth } from "../../../global-components/src";
import axios from "axios";
import { Post as PostType } from "../../../types";
import { PACOCA_API_URL } from "../../../global-components/src/utils/vars";
import UserSearch from "../../../pages/Settings/SearchScreen/User/User";
import PostLikesContent from "./post-likes-content";

interface ModalPostLikesProps {
    idPostSelected: number | null; // Define que posts é um array de Post
    open: boolean;
    setOpen: (val: boolean) => void;
}

const ModalPostLikes: React.FC<ModalPostLikesProps> = ({ open, setOpen, idPostSelected }) => {
    const closeModalLikesRef = useRef<HTMLButtonElement>(null);
    const openModalLikesRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        closeModalLikesRef.current?.click();
    }, [location.pathname]); // Executa toda vez que a URL muda

     useEffect(() => {
        if (open) {
            openModalLikesRef.current?.click()
        }
        else
            closeModalLikesRef.current?.click()
    }, [open])

    return (

        <div className="modal fade " id={"modal-likes"} aria-hidden="true">
            <div className="modal-dialog modal-dialog-likes modal-dialog-centered cover-mobile" role="document">
                <div className="modal-content modal-content-likes" id="modal-content-likes">
                    <div className="modal-header modal-header-likes">
                        {/* <h5 className="modal-title">Curtidas</h5> */}
                        <h4 className={`modal-title ml-5`} id="modal-curtida">Curtidas</h4>

                        <button ref={closeModalLikesRef} data-bs-dismiss="modal" aria-label="Close" type="button" className="btn-close"></button>
                    </div>
                    <div className="modal-body modal-body-likes overflow-minus">
                        <PostLikesContent open={open} idPostSelected={idPostSelected}/>
                    </div>
                </div>
            </div>

            <button className="d-none" ref={openModalLikesRef} data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target={"#modal-likes"}>a</button>
        </div>
    );
};

export default ModalPostLikes;
